<template>
    <GetStartedLayout
        :errors="errors"
        title=""
        subtitle=""
        :breadcrumbs="breadcrumbs"
        :helpForm="false"
        :guest="guest || user"
        :location="lesson.location"
        ref="layout"
        ><template #toggleFilter>
            <v-btn
                v-if="shoppingCartItems"
                icon
                outlined
                color="white"
                @click="$inertia.visit(route('checkout.show'))"
                ><v-badge
                    :content="shoppingCartItems"
                    color="secondary"
                    overlap
                    bordered
                >
                    <v-icon class="white--text">shopping_cart</v-icon></v-badge
                ></v-btn
            >
        </template>
        <v-col
            class="white--text text-center px-0"
            cols="12"
            sm="10"
            md="8"
            lg="6"
        >
            <FormTitle class="pa-4 pt-0" dark
                >{{ lesson.group_event.title }}
                <template #subtitle
                    ><v-list-item-avatar
                        ><v-img
                            :src="
                                lesson.details.teacher.profile_photo_url
                            " /></v-list-item-avatar
                    >{{ `with ${lesson.details.teacher.name}` }}</template
                >
            </FormTitle>
            <ClassRegistrationDetails
                :lesson="lesson"
                :errors="errors"
                :user="user"
                :autoCoupon="{
                    auto_coupon_name: 'Free First Class',
                    auto_coupon_amount: '$0',
                    original_amount: `${lesson.tuition.formatAmount}/child`,
                }"
            />

            <EventRegistrationGuest
                v-if="!user"
                v-model="guestData"
                :errors="errors"
                :guest="guest"
                :location="lesson.location"
                :eventRegister="lesson"
            />

            <ClassRegistrationAttending
                v-if="user || guest"
                :relationships="relationships"
                :lesson="lesson"
                :user="user"
                :guest="guest"
                :guestData="guestData"
                :errors="errors"
            />
        </v-col>
    </GetStartedLayout>
</template>

<script>
import Experience from "../../Components/GetStarted/Experience.vue";
import Lesson from "../../Components/GetStarted/Lesson.vue";
import GetStartedLayout from "../../Layouts/GetStartedLayout.vue";
import { Link } from "@inertiajs/vue2";
import StripePaymentElement from "../../Components/StripePaymentElement.vue";
import ClassRegistrationDetails from "../../Components/ClassRegistration/ClassRegistrationDetails.vue";
import EventRegistrationGuest from "../../Components/EventRegistration/EventRegistrationGuest.vue";
import ClassRegistrationAttending from "../../Components/ClassRegistration/ClassRegistrationAttending.vue";
import EventRegistrationPricing from "../../Components/EventRegistration/EventRegistrationPricing.vue";
import FormTitle from "../../Components/Form/FormTitle.vue";
import axios from "axios";

export default {
    components: {
        GetStartedLayout,
        Link,
        Lesson,
        Experience,
        StripePaymentElement,
        ClassRegistrationDetails,
        EventRegistrationGuest,
        ClassRegistrationAttending,
        EventRegistrationPricing,
        FormTitle,
    },
    props: {
        errors: {},
        lesson: {
            type: Object,
            default: () => {},
        },
        user: {
            type: Object,
            default: () => {},
        },
        guest: {
            type: Object,
            default: () => {},
        },
        relationships: {
            type: Array,
            default: () => [],
        },
        shoppingCartItems: {
            type: Number,
            default: 0,
        },
    },
    data: function () {
        return {
            loading: false,
            stepNumber: 1,
            appliedGift: null,
            appliedPromo: null,
            guestData: null,
        };
    },
    methods: {},
    computed: {
        breadcrumbs() {
            if (this.user?.id) {
                return ["Home", this.lesson.group_event.title, "Register"];
            }
            return ["Get Started", this.lesson.group_event.title, "Register"];
        },
    },
};
</script>

<style scoped></style>
